import type { FaireProductEntity } from "../../entity_types/product";

export const p_e46pwwz8q9: FaireProductEntity = {
  token: "p_e46pwwz8q9",
  type: "product",
  name: "BAMBOO KNOTTED GOWN- Chris Camo",
  brandToken: "b_26nge8afju",
  brandName: "millie + roo LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/5b32d205227188cb02dfd6b52947ca096883cfcc97a6e4b3e23b618ceaf35606.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7e134364e78d1e96ac3d0fefc8e68808f7c65ecd31d7f1541454446e9cd18e3d.jpeg",
  ],
  priceDollars: 17.6,
  description:
    "\nBringing home baby just got that much more sweet, our timeless knotted gown made with only the BEST Organic OEKO-tex certified Bamboo Viscose for your newest little family member!!\n\nWhen you combine classic and modern, you have the timeless knot gown.\n\nConstructed with a lap neck or easy on and off as well as fold over mittens to keep little little precious face clear of scratches from their tiny razor sharp fingernails \n\nKnotted bottom gives the feel of being secure for baby(without being swaddled) and makes diaper changes so easy!\n\nPlease review the size chart to ensure correct fit and snag a matching or coordinating beanie here!\n\nFacts about Bamboo Clothing:\n\n * super soft and can be compared to cashmere \n * temperature regulating - helping stay warm in winter and cool in summer \n * antimicrobial qualities- to help destroy and eliminate odor causing bacterias \n * ideal for sensitive skin- amazing for eczema \n * eco friendly \n * amazing stretch along with our sizing allows for room to grow with each size \nThis listing is for the gown only.",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:01.304Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
